export const CONTACT_INFO_TITLE = "Your contact information";
export const CONTACT_INFO_TITLE_MOBILE = "Contact information";
export const CONTACT_INFO_SUBTITLE =
  "This information is used to notify you about any updates or changes to your activity.";

export const CONTACT_INFO_NOTICE = (searchedTravelerCount: number) =>
  `You must select ${searchedTravelerCount} ${
    searchedTravelerCount === 1 ? "traveler" : "travelers"
  } and enter your contact information to continue.`;

export const CONTACT_INFO_NOTICE_NO_COMM = (searchedTravelerCount: number) =>
  `You must select ${searchedTravelerCount} ${
    searchedTravelerCount === 1 ? "traveler" : "travelers"
  } to continue.`;

export const CONTINUE_TEXT = "Continue";
export const SAVING_TEXT = "Saving";
